module.exports = __webpack_public_path__ + "img/ws.d893170e.svg";